import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import 'components/organisms/ListingViewMessageCenter/TabNotes/Note/styles.scss';
import PET_CONFIG from 'config/pet.config';
import { getUsers } from 'store/root/actions/messages.helpers';
import { updateNote } from 'store/root/actions/messages';

const Note = ({ note }) => {
  const [isExpand, setIsExpand] = useState(true);
  const [showReadMore, setShowReadMore] = useState(false);
  const [isTextEllipsis, setIsTextEllipsis] = useState('');
  const dispatch = useDispatch();

  const onExpandNote = () => {
    setShowReadMore(true);
    setIsExpand(true);
  };

  const onCollapseNote = () => {
    setShowReadMore(false);
    setIsExpand(false);
  };
  const noteClasses = `tab-notes__card tab-notes__card--${note.label}`;
  useEffect(() => {
    const isMessageShortShowItAll = note.message.length > 155;
    if (isMessageShortShowItAll) {
      setIsExpand(false);
    }
  }, [note.message.length]);

  useEffect(() => {
    if (isExpand) {
      setIsTextEllipsis('');
    } else {
      setIsTextEllipsis(
        'ant-typography-ellipsis ant-typography-ellipsis-multiple-line'
      );
    }
  }, [isExpand]);

  useEffect(() => {
    const isInternalNote = note.noteTypeId === PET_CONFIG.noteTypeId.internal;
    if (!isInternalNote) return;

    async function getAuthor() {
      const authorId = note.authorId;
      if (!authorId || note.authorName) {
        return;
      }
      const users = await getUsers([authorId]);
      const firstName = users?.[0]?.user?.firstName || '';
      const lastName = users?.[0]?.user?.lastName || '';
      note.authorName = `${firstName} ${lastName}`;
      dispatch(updateNote(note));
    }

    getAuthor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`${noteClasses} ant-card ant-card-body`}>
      <div className="tab-notes__title ant-typography ant-typography-secondary">
        <span className="tab-notes__date">
          {note.formattedDate} {note.authorName && `by ${note.authorName}`}
        </span>
        <span className="tab-notes__label">{note.label}</span>
      </div>
      <div className={`ant-typography ${isTextEllipsis}`}>{note.message}</div>
      {showReadMore && (
        <div
          onClick={onCollapseNote}
          className="tab-notes__expand ant-typography ant-typography-secondary"
        >
          Show less
        </div>
      )}
      {!isExpand && (
        <div
          onClick={onExpandNote}
          className="tab-notes__expand ant-typography ant-typography-secondary"
        >
          Read more
        </div>
      )}
    </div>
  );
};

Note.propTypes = {
  note: PropTypes.shape({
    label: PropTypes.string.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    noteTypeId: PropTypes.number.isRequired,
    authorId: PropTypes.number,
    authorName: PropTypes.string,
    formattedDate: PropTypes.string,
  }).isRequired,
};

export default Note;
